import Breadcrumb from "../Component/Breadcrumb";

function About() {
  return (
    <>
      <Breadcrumb></Breadcrumb>

      <div className="innersec about_sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>About</h1>
            </div>
            <p className="about-text">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/slider1.png"
                className="col-md-4 float-md-end left-img img-fluid"
              />
              <strong>ST. JOSEPH’S SCHOOL, BARHALGANJ</strong>, affiliated to
              the central board of secondary education, new delhi (aff. no.
              2131498) is an english medium christian minority educational
              institution established in 2007, administered and governed by the
              catholic diocese of gorakhpur education society, registered under
              the society's registration act. being governed by the catholic
              church a minority community, the school has the primary objective
              of educating the children of the community. however, we shall not
              spare any effort in rendering our service to all people,
              irrespective of caste and gender, so as to conserve their
              religion, language and culture.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default About;
